import { Box, CircularProgress } from "@mui/material";

export default function PageLoading({
  heightFit = false,
  sx,
}: {
  heightFit?: boolean;
  sx?: object;
}): React.JSX.Element {
  return (
    <Box
      sx={{
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        height: heightFit ? "300px" : "100vh",
        ...sx,
      }}
    >
      <CircularProgress />
    </Box>
  );
}
